import React from 'react'
import GlobalStyled from '../components/app/StyledApp'
import PurchaseDetailsPassenger from '../components/purchaseDetails/PurchaseDetails'


const PurchasePage = () => {
  return (
    <>
    <PurchaseDetailsPassenger />
    <GlobalStyled />
    </>
  )
}
export default PurchasePage